module.exports = __webpack_public_path__ + "img/Perry_Elizabeth.0bd6a24d.png";